import cortisolGraphEn from "@/assets/lottie/cortisolGraph.json";
import cortisolGraphEs from "@/assets/lottie/cortisolGraph-es.json";
import { Languages } from "@/constants/languages";

export const cortisolChartByLng = {
    [Languages.Spanish]: cortisolGraphEs,
    [Languages.English]: cortisolGraphEn,
    [Languages.German]: cortisolGraphEn,
};
